import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'convertMillisToMinutesSeconds' })
export class ConvertMillisToMinutesSecondsPipe implements PipeTransform {
  transform(millis: number | null | undefined): string {
    if (millis === null || millis === undefined || millis < 0) {
      return '-:--';
    }

    const minutes = Math.floor(millis / 60000);
    const seconds = Math.floor((millis % 60000) / 1000);

    return (
      (minutes < 10 ? '0' + minutes : minutes) +
      ':' +
      (seconds < 10 ? '0' + seconds : seconds)
    );
  }
}
